
/* eslint-disable object-curly-newline */

const TIME_FOR_PASTING_MESSAGES_INTO_GROUP = 60e3;

export const composeClassName = (author, isFirstInGroup, isLastInGroup, nextMessage = {}) => 'chat-message'
+ ` author-${author}`
+ `${isFirstInGroup ? ' is-first' : ''}`
+ `${isLastInGroup ? ' is-last' : ''}`
+ `${nextMessage && nextMessage.type ? ` next-message-type-${nextMessage.type}` : ''}`;

export const calculateIsLast = ({ nickname, date, type, nextMessageParams }) => {
  const hasMessageAfter = nextMessageParams && nextMessageParams.id;

  return !hasMessageAfter
  || nickname !== nextMessageParams.nickname
  || type !== nextMessageParams.type
  || nextMessageParams.date - date > TIME_FOR_PASTING_MESSAGES_INTO_GROUP;
};

export const calculateIsFirst = ({ prevMessageParams, nickname, date, type }) => {
  const hasMessageBefore = prevMessageParams && prevMessageParams.id;

  return !hasMessageBefore
  || nickname !== prevMessageParams.nickname
  || type !== prevMessageParams.type
  || date - prevMessageParams.date > TIME_FOR_PASTING_MESSAGES_INTO_GROUP;
};
